import { createFileRoute } from "@tanstack/react-router";
import UnderConstruction from "@/components/errors/UnderConstruction";

export const Route = createFileRoute("/_protected/admin/reports")({
	component: () => <UnderConstruction />,
});
